import Balance from "./Balance";
import background from "assets/images/background.png";
import b1 from "assets/images/b1.png";
import b1dark from "assets/images/b2.png";
import NotificationIcon from "./NotificationIcon";

export default function Header() {
  return (
    <div className="relative">
      <div className="px-4 relative max-w-[500px]">
        <div className="absolute left-0 right-0" style={{ zIndex: "-1" }}>
          <img
            src={background}
            alt="b"
            className="absolute absolute-0 w-full"
          />
          <img
            src={b1}
            alt="b1"
            className="dark:hidden absolute top-0 w-full"
          />
          <img
            src={b1dark}
            alt="b1dark"
            className="hidden dark:block absolute top-0 w-full"
          />
        </div>
      </div>

      <div className="px-4">
        <NotificationIcon />
      </div>
      <Balance />
    </div>
  );
}
